import { SearchX } from 'lucide-react';
import PropTypes from 'prop-types';
import { useTranslation } from '@aimsos/i18n';
import DashboardButton from './DashboardButton';

/**
 * The Created tab when filters match nothing (CT-5468).
 *
 * Not the blank-slate empty state: "Start building your dashboard" told a user
 * who had dashboards — just none matching — that they had none. This says what
 * actually happened and offers the way back.
 */
const DashboardNoResults = ({ onClearFilters }) => {
  const { t } = useTranslation('dashboards');

  return (
    <section className="flex flex-col items-center gap-4 rounded-2xl border border-edge bg-surface px-6 py-10 text-center">
      <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-brand-50 text-brand-600 dark:bg-brand-950/40 dark:text-brand-400">
        <SearchX size={20} aria-hidden />
      </span>
      <h2 className="text-lg font-semibold text-content">{t('list.noResults.title')}</h2>
      <p className="max-w-xl text-sm text-content-muted">{t('list.noResults.description')}</p>
      <DashboardButton variant="secondary" onClick={onClearFilters}>
        {t('filters.clear')}
      </DashboardButton>
    </section>
  );
};

DashboardNoResults.propTypes = {
  onClearFilters: PropTypes.func.isRequired,
};

export default DashboardNoResults;
